import { Directive, input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { DateTime } from 'luxon';

type MinDateValue = Date | string;

@Directive({
    selector: '[minDate][formControlName],[minDate][formControl],[minDate][ngModel]',
    providers: [{ provide: NG_VALIDATORS, useExisting: MinDateDirective, multi: true }],
})
export class MinDateDirective implements Validator {
  minDate = input<MinDateValue | undefined>();

  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value as MinDateValue | null;
    const minDate = this.minDate();
    if (!minDate || !value) return null;
    return this.formatDate(value) < this.formatDate(minDate) ? { minDate: true } : null;
  }

  private formatDate(date: MinDateValue): string {
    if (date instanceof Date) return DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');
    return DateTime.fromISO(date).toFormat('yyyy-MM-dd');
  }
}
